export const normalizeSearchTerm = value => String(value || '').normalize('NFKC').trim().replace(/\s+/g, ' ');
export const matchesProductSearch = (product, query) => {
    const terms = normalizeSearchTerm(query).toLocaleLowerCase().split(' ').filter(Boolean);
    if (!terms.length) return true;
    const names = ['ProductName', 'label', 'CategoryName', 'ManufacturerName', 'ShortDescription'];
    const text = names.map(name => {
        const key = Object.keys(product || {}).find(field => field.toLowerCase() === name.toLowerCase());
        return key ? String(product[key] || '') : '';
    }).join(' ').normalize('NFKC').toLocaleLowerCase();
    return terms.every(term => text.includes(term));
};
export const filterProductsBySearch = (products, query) => (products || []).filter(product => matchesProductSearch(product, query));
export const getProductSearchUrl = (language, query) => '/' + language + '/all-products/0/all-categories?' + new URLSearchParams({SearchTerm: normalizeSearchTerm(query)}).toString();
